import React from 'react';
import { Col } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Map from 'src/components/maps/MapPage.componentMainPage';
import { useLoadScript } from "@react-google-maps/api";
import { environment } from 'src/environments/environment';

const UseStyles = makeStyles({
    gridContainerStyle: {
        marginLeft: '-32px',
        marginTop: '-85px'
    }
});

const MapPageMainPage = (props) => {
    const classes = UseStyles(props);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: environment.googleMapsApiKey,
        libraries: ["places"]
    });

    return (
        <Col md={12} lg={12}>
            <Grid container className={classes.gridContainerStyle} >
                <Grid item xs={12} md={12}>
                    {isLoaded && <Map />}
                </Grid>
            </Grid>
        </Col>
    );
};

export default MapPageMainPage;